import { Text } from '@chakra-ui/react';

import CoverageConsentModal from './CoverageConsentModal';

interface DcpdDeclineConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (consentMethod: number) => void;
  isLoading?: boolean;
}

const DcpdDeclineConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: DcpdDeclineConfirmationModalProps) => {
  const warningContent = (
    <>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        Direct Compensation - Property Damage (DCPD) is a recommended coverage.
      </Text>
      <Text fontSize="sm">
        DCPD covers damage to your vehicle and its contents when another driver
        is at fault. This coverage allows you to claim directly from your own
        insurer rather than pursuing the at-fault driver&apos;s insurance
        company.
      </Text>
    </>
  );

  return (
    <CoverageConsentModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      isLoading={isLoading}
      title="DCPD Coverage Decline"
      warningContent={warningContent}
      attestationText="I have advised my client of the DCPD coverage and its importance. Client has agreed to opt out of this coverage regardless of recommendation."
    />
  );
};

export default DcpdDeclineConfirmationModal;
